import { supabase } from "../../../supabaseClient";

export async function fetchTeamsForSquads(squadIds) {
  if (!squadIds.length) return [];

  const { data, error } = await supabase
    .from("teams")
    .select("id, squadID")
    .in("squadID", squadIds)
    .eq("isDeleted", false);

  if (error) throw error;
  return data; // Return full team objects with squadID
}
